function productGrid() {
  var options = [],
  variant = '',
  thisCard = '',
  imageId = '',
  available = '';

  jQuery('.card-wrapper .swatch').on('click',function() {
    thisCard = jQuery( this ).parents( '.card-wrapper' );
    
    thisCard.find('.swatches .swatch').removeClass('active');
    jQuery( this ).addClass('active');

  });

  jQuery('.card-wrapper .swatch-radio').change( function () {
    options = [];
    variant = '';
    thisCard = jQuery( this ).parents( '.card-wrapper' );

    thisCard.find('.swatches').each(function() {
      options.push( $(this).find('input[type=radio]:checked').val() );
    });

    variant = options.join(' / ');

    thisCard.find('.variants option[data-value="'+ variant + '"]')
    .prop("selected", true);

    imageId = thisCard.find('.variants option:selected').data('image-id');
    available = thisCard.find('.variants option:selected').data('available');

    if ( imageId != '') {
      thisCard.find('.media [data-image-id]').css('opacity', 0);
      thisCard.find('.media [data-image-id="' + imageId + '"]').css('opacity', 1);
    }

    if ( available == true) {
      thisCard.find('.button[type="submit"]').removeClass('sold-out').html('Add to Cart').prop('disabled', false);
    } else {
      thisCard.find('.button[type="submit"]').addClass('sold-out').html('Sold Out').prop('disabled', true);
    }

    options = []; // Clear the array
  });

  jQuery('.card-wrapper').each(function () {
    options = [];
    variant = '';
    thisCard = jQuery( this );

    thisCard.find('.swatches').each(function() {
      options.push( $(this).find('input[type=radio]:checked').val() );
    });

    variant = options.join(' / ');

    thisCard.find('.variants option[data-value="'+ variant + '"]')
    .prop("selected", true);

    imageId = thisCard.find('.variants option:selected').data('image-id');
    available = thisCard.find('.variants option:selected').data('available');

    if ( imageId != '') {
      thisCard.find('.media [data-image-id]').css('opacity', 0);
      thisCard.find('.media [data-image-id="' + imageId + '"]').css('opacity', 1);
    }

    if ( available == true) {
      thisCard.find('.button[type="submit"]').removeClass('sold-out').html('Add to Cart').prop('disabled', false);
    } else {
      thisCard.find('.button[type="submit"]').addClass('sold-out').html('Sold Out').prop('disabled', true);
    }

    options = []; // Clear the array
  });
}

jQuery( document ).ready(function () {
  productGrid();
});
